'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NavbarContextType {
    isVisible: boolean;
    setIsVisible: (visible: boolean) => void;
}

const NavbarContext = createContext<NavbarContextType | undefined>(undefined);

export const NavbarProvider = ({ children }: { children: ReactNode }) => {
    const [isVisible, setIsVisible] = useState(true);

    return (
        <NavbarContext.Provider value={{ isVisible, setIsVisible }}>
            {children}
        </NavbarContext.Provider>
    );
};

export const useNavbar = () => {
    const context = useContext(NavbarContext);
    if (!context) {
        throw new Error('useNavbar must be used within a NavbarProvider');
    }
    return context;
};
